var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 117,
    viewBox: "0 0 152 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.30769C1 2.03319 2.03319 1 3.30769 1H148.692C149.967 1 151 2.03319 151 3.30769V113.692C151 114.967 149.967 116 148.692 116H3.30769C2.03319 116 1 114.967 1 113.692V3.30769Z",
    stroke: "#292929"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9619 9.30784C19.9619 9.07418 20.1513 8.88477 20.385 8.88477H32.385C32.6186 8.88477 32.8081 9.07418 32.8081 9.30784V16.6925C32.8081 16.9261 32.6186 17.1155 32.385 17.1155H20.385C20.1513 17.1155 19.9619 16.9261 19.9619 16.6925V9.30784ZM69.3465 9.30784C69.3465 9.07418 69.5359 8.88477 69.7696 8.88477H81.7696C82.0033 8.88477 82.1927 9.07418 82.1927 9.30784V16.6925C82.1927 16.9261 82.0033 17.1155 81.7696 17.1155H69.7696C69.5359 17.1155 69.3465 16.9261 69.3465 16.6925V9.30784ZM119.193 9.30784C119.193 9.07418 119.382 8.88477 119.616 8.88477H131.616C131.849 8.88477 132.039 9.07419 132.039 9.30784V16.6925C132.039 16.9261 131.849 17.1155 131.616 17.1155H119.616C119.382 17.1155 119.193 16.9261 119.193 16.6925V9.30784Z",
    stroke: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBench);
export default __webpack_public_path__ + "static/media/bench.626119f3835002b36015b7afbc0defb9.svg";
export { ForwardRef as ReactComponent };